import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { FaPlus, FaTimes } from 'react-icons/fa';
import './TagsModal.css';

const TagsModal = ({
    isOpen,
    onClose,
    customer,
    availableTags,
    onUpdateTags,
    onCreateTag
}) => {
    const [selectedTags, setSelectedTags] = useState([]);
    const [newTag, setNewTag] = useState('');
    const [isCreating, setIsCreating] = useState(false);

    useEffect(() => {
        if (customer && customer.tags) {
            setSelectedTags(customer.tags);
        } else {
            setSelectedTags([]);
        }
    }, [customer]);

    const handleToggleTag = (tag) => {
        if (selectedTags.includes(tag)) {
            setSelectedTags(selectedTags.filter(t => t !== tag));
        } else {
            setSelectedTags([...selectedTags, tag]);
        }
    };

    const handleCreateTag = async () => {
        if (newTag.trim()) {
            setIsCreating(true);
            await onCreateTag(newTag.trim());
            setNewTag('');
            setIsCreating(false);
        }
    };

    const handleSave = () => {
        onUpdateTags(customer, selectedTags);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <Modal onClose={onClose}>
            <div className="tags-modal-content">
                <h3>Manage Tags for {customer?.name}</h3>

                <div className="current-tags-section">
                    <h4>Selected Tags</h4>
                    <div className="tags-list">
                        {selectedTags.length > 0 ? (
                            selectedTags.map(tag => (
                                <span key={tag} className="tag-chip selected">
                                    {tag}
                                    <FaTimes
                                        className="remove-tag-icon"
                                        onClick={() => handleToggleTag(tag)}
                                    />
                                </span>
                            ))
                        ) : (
                            <p className="no-tags-text">No tags selected</p>
                        )}
                    </div>
                </div>

                <div className="available-tags-section">
                    <h4>Available Tags</h4>
                    <div className="tags-list">
                        {availableTags.filter(tag => !selectedTags.includes(tag)).map(tag => (
                            <span
                                key={tag}
                                className="tag-chip available"
                                onClick={() => handleToggleTag(tag)}
                            >
                                {tag} <FaPlus className="add-tag-icon" />
                            </span>
                        ))}
                    </div>
                </div>

                <div className="create-tag-section">
                    <input
                        type="text"
                        placeholder="Create new tag..."
                        value={newTag}
                        onChange={(e) => setNewTag(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleCreateTag()}
                    />
                    <button
                        onClick={handleCreateTag}
                        disabled={!newTag.trim() || isCreating}
                        className="create-tag-btn"
                    >
                        {isCreating ? 'Creating...' : 'Create'}
                    </button>
                </div>

                <div className="modal-actions">
                    <button onClick={onClose} className="cancel-btn">Cancel</button>
                    <button onClick={handleSave} className="save-btn">Save Changes</button>
                </div>
            </div>
        </Modal>
    );
};

export default TagsModal;
